<template>
    <div>
        <div class="item" v-if="sentiment.sentiments.staff">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <h4 class="display-4">Ratings</h4>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Staff</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.staff / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.staff / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.location">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Location</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.location / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.location / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.service">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Service</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.service / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.service / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.roomComforts">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Room Comfort</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.roomComforts / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.roomComforts / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.internet">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Internet</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.internet / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.internet / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.sleepQuality">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Sleep Quality</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.sleepQuality / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.sleepQuality / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.valueForMoney">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Value For Money</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.valueForMoney / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.valueForMoney / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.facilities">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Facilities</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.facilities / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.catering / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.catering">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Catering</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.catering / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.catering / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.swimmingPool">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Swimming Pool</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.swimmingPool / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.swimmingPool / 10).toFixed(1) }}</div>
            </div>
        </div>
        <div class="item" v-if="sentiment.sentiments.pointsOfInterest">
            <div class="row align-items-center">
                <div class="col-md-4 text-md-right">
                    <div class="rating-label">Points Of Interest</div>
                </div>
                <div class="col-md-7">
                    <b-progress :value="sentiment.sentiments.pointsOfInterest / 10" :max="10" :precision="0" class="rating-bar"></b-progress>
                </div>
                <div class="col-md-1 rating-number">{{ parseFloat(sentiment.sentiments.pointsOfInterest / 10).toFixed(1) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Sentiment',
        props: {
            sentiment: {
                type: Object,
                required: true
            },
        }
    }
</script>

<style scoped>
    .rating-bar{
        height:8px;
    }
    .rating-number{
        font-size: 0.7rem;
        color: #888;
    }
    .rating-label{
        font-size:15px;
    }
    #sentiment .item{
        margin-bottom:10px;
    }
</style>
